import {
  subscriptionTypeToPlanTypeMap,
  type UserPlanType,
} from '../useUserSubscription.types';
import { type UserSubscriptionType } from '../../../services/subscriptions';

export const getUserPlanType = (
  plan?: UserSubscriptionType,
): UserPlanType | undefined => {
  const userPlanType = plan && subscriptionTypeToPlanTypeMap[plan];
  return userPlanType;
};
